import i18n from "@/i18n";
import PageForm from "@/assets/ts/interfaces/form/pageForm";
import { Types } from "@/assets/ts/enums/form/types";
const order = ['sustainable_energy', 'water_and_blue_economy', 'green_use_of_land', 'social_economy', 'business_in_transition'];

function getSDG() {
  const sdg: PageForm =
  {
    title: i18n.global.t('proposal.form.side_panel.title'),
    image: require('@/assets/img/windmill.png'),
    imageCircle: true,
    name: i18n.global.t('proposal.form.side_panel.sdg'),
    form: [
      {
        title: '',
        titleMobile: i18n.global.t('proposal.form.sdgs.title_mobile'),
        fields: [
          {
            title: i18n.global.t('proposal.form.sdgs.title'),
            subtitle: i18n.global.t('proposal.form.sdgs.subtitle'),
            key: "sustainable_development",
            value: "",
            options: i18n.global.tm("proposal.form.sdgs.options"),
            rules: "required",
            separatedRadio: true,
            grided: true,
            type: Types.RADIO
          },
          {
            key: "sustainable_development_category",
            value: "",
            title: i18n.global.t("proposal.form.sdgs.categories.title"),
            options: order.reduce((obj, key) => {
              // @ts-ignore
              return { ...obj, [key]: i18n.global.tm("proposal.form.sdgs.categories.options")[key] };
            }, {}),
            images: 'categories',
            rules: "required",
            separatedRadio: true,
            conditionalOn: "sustainable_development",
            conditionalOnValue: "true",
            endNote: i18n.global.t("proposal.form.sdgs.categories.end_note"),
            type: Types.RADIO
          }
          ,
          {
            key: "sdgs",
            value: [],
            title: i18n.global.t("proposal.form.sdgs.sdgs.title"),
            subtitle: i18n.global.t("proposal.form.sdgs.sdgs.subtitle"),
            options: i18n.global.tm("proposal.form.sdgs.sdgs.options"),
            conditionalOn: "sustainable_development",
            conditionalOnValue: "true",
            type: Types.SDGS,
            rules: "required"
          }
        ],
        next: true,
        back: true
      }
    ],
    sub_steps: []
  }
  return sdg
}

export default getSDG
